'use strict';
import DataQueryList from './mx-data-query-list';

angular.module('mx.SolutionBuilderAgent').component('mxContentWidgetViewList', {
	transclude: true,
	bindings: {
		parameters: '=',
		outputPreprocessors: '<',
	},
	controller: MxContentWidgetViewListCtrl,
	controllerAs: 'vm',
	templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-content-widget-view/list/mx-content-widget-view-list.html',
});

MxContentWidgetViewListCtrl.$inject = ['$injector', '$element', '$scope'];

MxContentWidgetViewListCtrl.prototype = Object.create(DataQueryList.prototype);

function MxContentWidgetViewListCtrl($injector, $element, $scope) {
	var vm = this;

	vm.$onInit = function () {
		vm.type = mx.SolutionBuilderAgent.ListingType.list;

		vm.initialize($injector, $scope);
		if (typeof vm.outputPreprocessors === 'object') {
			angular.extend(vm.outputPreprocessors, vm.preprocessorsByName);
		}
		vm.load();
	};

	vm.$postLink = function () {
		var sortingPanel = $element.find('mx-workspace-common-order-panel');

		angular.element('.mx-search-page-place-holder').empty().append(sortingPanel);
	};

	$scope.$watch('vm.loading', function (value) {
		vm.pagingPreprocessor.loading = value;
	});

	return vm;
}
